import { useContext, useState, Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Stack, Typography, ListItem, Collapse, Box } from "@mui/material";
//Icons
import { ExpandLess, ExpandMore } from "@mui/icons-material";
//Import from project
import { AuthContext } from "../../Context/AuthContext";
import LogoSystem from "../../Assets/Logo.png";
import { menuDataArray, collapseDataArray } from "./MenuData";
import "./menu.scss";

// Collapse menu config

export default function Menu() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useContext(AuthContext);

  const menuData = menuDataArray();

  // Keep track of open collapse menus by subName
  const [openCollapse, setOpenCollapse] = useState({});

  const toggleCollapse = (subName) => {
    setOpenCollapse((prev) => {
      const isCurrentlyOpen = prev[subName];
      // Close all collapses, then toggle the clicked one
      return { [subName]: !isCurrentlyOpen };
    });
  };

  return (
    <Box className="menu-container">
      <Stack
        direction="column"
        spacing={2}
        sx={{ width: "100%", padding: "10px" }}
      >
        {/* ============================================ Main Menu ========================================== */}
        <Stack direction="row" justifyContent="center">
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="logo-container"
          >
            <img src={LogoSystem} style={{ width: "100px" }} alt="logo" />
          </Stack>
        </Stack>

        {/* <Typography className="main-title">{subMenu?.name}</Typography> */}
        <Box className="menu-body">
          <Stack direction="column" spacing={0.3}>
            {menuData?.map((menu, index) => {
              return (
                <Fragment key={index}>
                  {!menu.isCollapse ? (
                    // ========================================== Normal sub menu ===================================
                    <ListItem
                      disablePadding
                      onClick={() => {
                        navigate(menu.route);
                        setOpenCollapse({});
                      }}
                      className={
                        location.pathname === menu.route ||
                        (Array.isArray(menu.include) &&
                          menu.include.includes(location.pathname))
                          ? "list-item-active"
                          : "list-item"
                      }
                    >
                      <Stack direction="row" spacing={1.4}>
                        <Stack direction="column" justifyContent="center">
                          {menu.icon}
                        </Stack>
                        <Typography className="list-item-text">
                          {t(menu.name)}
                        </Typography>
                      </Stack>
                    </ListItem>
                  ) : (
                    // ========================================== Collapsible sub menu =================================
                    <ListItem
                      disablePadding
                      onClick={() => toggleCollapse(menu.subName)}
                      className="list-item"
                    >
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        sx={{ width: "100%", marginRight: "14px" }}
                      >
                        <Stack direction="row" spacing={1.4}>
                          {/* <Stack direction="column" justifyContent="center">
                            {menu.icon}
                          </Stack> */}
                          {/* {openCollapse[menu.subName] ? (
                              <Stack
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                className="expand-icon"
                              >
                                <ExpandMore
                                  style={{ color: "#fff", fontSize: "20px" }}
                                />
                              </Stack>
                            ) : (
                              <Stack
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                className="expand-icon"
                              >
                                <ExpandLess
                                  style={{ color: "#fff", fontSize: "20px" }}
                                />
                              </Stack>
                            )} */}
                          <Typography className="list-item-text">
                            {menu.subName}
                          </Typography>
                        </Stack>
                      </Stack>
                    </ListItem>
                  )}

                  {/* ======================================= Collapse items ================================================ */}
                  {/* {menu.isCollapse &&
                      collapseMenu?.collapseData?.length > 0 && (
                        <Collapse
                          in={openCollapse[menu.subName]}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Stack direction="column" spacing={1}>
                            {collapseMenu.collapseData.map((row) => (
                              <ListItem
                                key={row.route}
                                disablePadding
                                onClick={() => navigate(row.route)}
                                className={
                                  location.pathname === row.route
                                    ? "subMenu-list-item-active"
                                    : "subMenu-list-item"
                                }
                              >
                                <Stack
                                  direction="row"
                                  spacing={1.4}
                                  sx={{ paddingLeft: "14px" }}
                                >
                                  <Stack
                                    direction="column"
                                    justifyContent="center"
                                  >
                                    {row.icon}
                                  </Stack>
                                  <Typography className="list-item-text">
                                    {row.subName}
                                  </Typography>
                                </Stack>
                              </ListItem>
                            ))}
                          </Stack>
                        </Collapse>
                      )} */}
                </Fragment>
              );
            })}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
